module.exports = __webpack_public_path__ + "img/empty-flight-schedule.81fc609a.svg";